<template>
    <div class="container flex flex-direction">
        <dv-loading v-if="loading" class="loading">Loading...</dv-loading>
        <div class="header-container flex align-center justify-between">
            <div class="flex align-center">
                <div class="btn-container" @click="$router.go(-1)">
                    <div class="btn"><i class="iconfont icon-fanhui margin-right-xs"></i>返回</div>
                </div>
                <!--                <el-dropdown class="xiaoqu" trigger="click" @command="handleCommand" v-if="user.power === 3">-->
                <!--                    <div class="btn-container mid">-->
                <!--                        <div class="btn">-->
                <!--                            {{ project_name || '全部社区' }}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <el-dropdown-menu slot="dropdown">-->
                <!--                        <el-dropdown-item v-for="(item,index) in projects" :key="index" :command="item">{{ item.name }}-->
                <!--                        </el-dropdown-item>-->
                <!--                    </el-dropdown-menu>-->
                <!--                </el-dropdown>-->
            </div>
            <div class="page-title">双暖孝亲安全守护平台</div>
            <div class="flex align-center">
                <div class="btn-container max right margin-left-sm">
                    <div class="btn">{{ cur_time|date_time }}</div>
                </div>

            </div>
        </div>
        <div class="content-container flex flex-direction flex-sub">
            <div class="maps">
                <img :src="mapImg" alt="">
            </div>
            <div class="content-info-container flex flex-direction">
                <div class="info-container total-container flex flex-wrap justify-between">
                    <div class="total-item flex align-center" v-if="total.mouth_save_order_num_style">
                        <img class="image" src="../../../assets/img/data/icon_service_info_total_3.png">
                        <div class="flex flex-direction">
                            <div class="flex">
                                <dv-digital-flop :config="{style:style,number:[total.mouth_save_order_num],content:'{nt}'}"
                                                 class="number" :style="total.mouth_save_order_num_style"/>
                                <div class="label self-end">户次</div>
                            </div>
                            <div class="title margin-top-xs">本月预警</div>
                        </div>
                    </div>
                    <div class="total-item flex align-center" v-if="total.today_save_order_num_style">
                        <img class="image" src="../../../assets/img/data/icon_service_info_total_2.png">
                        <div class="flex flex-direction">
                            <div class="flex">
                                <dv-digital-flop :config="{style:style,number:[total.today_save_order_num],content:'{nt}'}"
                                                 class="number" :style="total.today_save_order_num_style"/>
                                <div class="label self-end">户次</div>
                            </div>
                            <div class="title margin-top-xs">今日预警</div>
                        </div>
                    </div>
                    <div class="total-item flex align-center" v-if="total.finish_save_order_num_style">
                        <img class="image" src="../../../assets/img/data/icon_service_info_total_2.png">
                        <div class="flex flex-direction">
                            <div class="flex">
                                <dv-digital-flop :config="{style:style,number:[total.finish_save_order_num],content:'{nt}'}"
                                                 class="number" :style="total.finish_save_order_num_style"/>
                                <div class="label self-end">户次</div>
                            </div>
                            <div class="title margin-top-xs">已处理</div>
                        </div>
                    </div>
                    <div class="total-item flex align-center" v-if="total.unfinish_save_order_num_style">
                        <img class="image" src="../../../assets/img/data/icon_service_info_total_2.png">
                        <div class="flex flex-direction">
                            <div class="flex">
                                <dv-digital-flop :config="{style:style,number:[total.unfinish_save_order_num],content:'{nt}'}"
                                                 class="number" :style="total.unfinish_save_order_num_style"/>
                                <div class="label self-end">户次</div>
                            </div>
                            <div class="title margin-top-xs">待处理</div>
                        </div>
                    </div>
                </div>
                <div class="info-container total-container flex flex-wrap justify-between margin-top-sm">
                    <div class="total-item flex align-center" v-if="total.electricity_order_num_style">
                        <i class="icon iconfont icon-dian"></i>
                        <div class="flex flex-direction">
                            <div class="title margin-bottom-xs">漏电警报</div>
                            <div class="flex">
                                <dv-digital-flop :config="{style:style,number:[total.electricity_order_num],content:'{nt}'}"
                                                 class="number" :style="total.electricity_order_num_style"/>
                                <div class="label self-end">户次</div>
                            </div>
                        </div>
                    </div>
                    <div class="total-item flex align-center" v-if="total.water_order_num_style">
                        <i class="icon iconfont icon-shenghuoshuibengfang"></i>
                        <div class="flex flex-direction">
                            <div class="title margin-bottom-xs">水感警报</div>
                            <div class="flex">
                                <dv-digital-flop :config="{style:style,number:[total.water_order_num],content:'{nt}'}"
                                                 class="number" :style="total.water_order_num_style"/>
                                <div class="label self-end">户次</div>
                            </div>
                        </div>
                    </div>
                    <div class="total-item flex align-center" v-if="total.smoke_order_num_style">
                        <i class="icon iconfont icon-shenghuoshuibengfang"></i>
                        <div class="flex flex-direction">
                            <div class="title margin-bottom-xs">烟感警报</div>
                            <div class="flex">
                                <dv-digital-flop :config="{style:style,number:[total.smoke_order_num],content:'{nt}'}"
                                                 class="number" :style="total.smoke_order_num_style"/>
                                <div class="label self-end">户次</div>
                            </div>
                        </div>
                    </div>
                    <div class="total-item flex align-center" v-if="total.fall_order_num_style">
                        <i class="icon iconfont icon-Pilates"></i>
                        <div class="flex flex-direction">
                            <div class="title margin-bottom-xs">摔倒警报</div>
                            <div class="flex">
                                <dv-digital-flop :config="{style:style,number:[total.fall_order_num],content:'{nt}'}"
                                                 class="number" :style="total.fall_order_num_style"/>
                                <div class="label self-end">户次</div>
                            </div>
                        </div>
                    </div>
                    <div class="total-item max flex align-center justify-center" v-if="total.charge_order_num_style">
                        <i class="icon iconfont icon-dianchi-chongdian"></i>
                        <div class="flex flex-direction">
                            <div class="title margin-bottom-xs">充电过载警报</div>
                            <div class="flex">
                                <dv-digital-flop :config="{style:style,number:[total.charge_order_num],content:'{nt}'}"
                                                 class="number" :style="total.charge_order_num_style"/>
                                <div class="label self-end">户次</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="content-info-container right">
                <div class="info-container yj-total-container flex flex-direction flex-sub">
                    <div class="classify-title self-center">预警记录</div>
                    <div class="operate-container flex align-center justify-between">
                        <div class="operate" @click="yibanRefresh"><i class="iconfont icon-shuaxin"></i> 刷新</div>
                        <div class="flex align-center">
                            <div class="operate" @click="yibanLast">上一页</div>
                            <div class="page">{{ yj_yiban_page }}/{{ yj_yiban_total_page }}</div>
                            <div class="operate" @click="yibanNext">下一页</div>
                        </div>
                    </div>
                    <el-empty v-if="!yj_yiban_list.length"></el-empty>
                    <div class="flex flex-direction margin-top-xs">
                        <div class="yj-item flex align-center" :class="item.state === 3 ? '' : 'error'"
                             v-for="(item,index) in yj_yiban_list" :key="index" @click="showYujing(item)">
                            <div class="tip-container flex flex-direction justify-center align-center">
                                <div class="type">{{ item.service_type|type }}</div>
                                <div class="tip">{{ item.state|service_type }}</div>
                            </div>
                            <div class="flex flex-direction">
                                <div class="flex align-center">
                                    <div class="name">{{ item.name }}</div>
                                    <div class="phone margin-left-xs">{{ item.phone }}</div>
                                </div>
                                <div class="address margin-top-xs">{{ item.xiaoqu_name }}{{ item.building_name
                                    }}{{ item.element_name }}单元{{ item.room_name }}
                                </div>
                            </div>
                            <div class="time">{{ item.add_time }}</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <safety-yujing-dialog :dialog="safetyYujingDialog" :detail="cur_item" @cancelDialog="cancelDialog"></safety-yujing-dialog>
    </div>
</template>

<script>

import {filesCNOher, zhDate} from "@/utils/utils";
import {dataScreenDeviceTotal, getSaveDeviceList, getXiangMuMap} from "@/api/tongji";
import {getXiangMuList} from "@/api/common";
import SafetyYujingDialog from "@/views/digitize/components/SafetyYujingDialog";

export default {
    name: "service_info",
    components: {SafetyYujingDialog},
    data() {
        return {
            mapImg: '',
            cur_time: new Date().getTime(),
            style: {
                fontSize: 26,
                fill: '#ffd200',
                fontFamily: 'PingFang SC',
                fontWeight: 'bold',
                fontStyle: 'italic'
            },

            loading: false,
            total: {
                charge_order_num: 0,
                electricity_order_num: 0,
                fall_order_num: 0,
                finish_save_order_num: 0,
                mouth_save_order_num: 0,
                smoke_order_num: 0,
                today_save_order_num: 0,
                unfinish_save_order_num: 0,
                water_order_num: 0,
            },

            yj_yiban_list: [],
            yj_yiban_page: 1,
            yj_yiban_total_page: 1,

            project_id: '',
            project_name: '',
            projects: [{id: 0, name: '全部社区'}],
            cur_item: '',
            safetyYujingDialog: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.project_id = this.$route.query.xiangmu_id
        this.getCurrentTime()
        this.getMap()
    },
    mounted() {
        this.onload()
    },
    methods: {
        async getMap() {
            const res = await getXiangMuMap(this.xiangmu_id)
            this.mapImg = res.data
        },
        onload() {
            this.loading = true
            this.init()
            if (this.user.power === 3) this.getXiangMuList()
            this.getYibanSaveList()
            this.setTimeoutGetData()
        },
        async getXiangMuList() {
            let _data = await getXiangMuList()
            this.projects = [...this.projects, ..._data.data]
            if (this.project_id) this.project_name = filesCNOher(Number(this.project_id), this.projects)
        },
        handleCommand(item) {
            this.project_id = item.id
            this.project_name = item.name
            history.replaceState('', '', window.location.origin + window.location.pathname + `${this.project_id ? `?xiangmu_id=${this.project_id}` : ''}`)
            this.total.jumin_equipment_num_style = ''
            this.loading = true
            this.init()
            this.getYibanSaveList()
        },
        setTimeoutGetData() {
            setInterval(() => {
                this.init()
                this.getYibanSaveList()
            }, 1000 * 60)
        },
        async getYibanSaveList() {
            let _data = await getSaveDeviceList(this.xiaoqu_id, '', this.yj_yiban_page, 6, this.project_id)
            _data.data.map(item => {
                let _info = item.emergency_contact.split('-')
                if (_info.length) {
                    item.name = _info[0]
                    item.phone = _info[1]
                }
            })
            this.yj_yiban_total_page = _data.total_page
            this.yj_yiban_list = _data.data
            let filter = this.yj_yiban_list.filter(f => {
                return f.state === 2
            });
            // let filter = this.yj_yiban_list.filter(f=>{ return f.is_read === 0});
            if (filter.length) {
                this.cur_item = filter[0]
                this.safetyYujingDialog = true
            }
        },
        yibanLast() {
            if (this.yj_yiban_page <= 1) return
            this.yj_yiban_page--
            this.getYibanSaveList()
        },
        yibanNext() {
            if (this.yj_yiban_page === this.yj_yiban_total_page) return
            this.yj_yiban_page++
            this.getYibanSaveList()
        },
        yibanRefresh() {
            this.yj_yiban_page = 1
            this.getYibanSaveList()
        },
        //  获取数据
        async init() {
            let _data = await dataScreenDeviceTotal(this.project_id)
            _data.data.charge_order_num_style = this.getStyle(_data.data.charge_order_num)
            _data.data.electricity_order_num_style = this.getStyle(_data.data.electricity_order_num)
            _data.data.fall_order_num_style = this.getStyle(_data.data.fall_order_num)
            _data.data.finish_save_order_num_style = this.getStyle(_data.data.finish_save_order_num)
            _data.data.mouth_save_order_num_style = this.getStyle(_data.data.mouth_save_order_num)
            _data.data.smoke_order_num_style = this.getStyle(_data.data.smoke_order_num)
            _data.data.today_save_order_num_style = this.getStyle(_data.data.today_save_order_num)
            _data.data.unfinish_save_order_num_style = this.getStyle(_data.data.unfinish_save_order_num)
            _data.data.water_order_num_style = this.getStyle(_data.data.water_order_num)
            this.total = _data.data
            this.loading = false
        },
        getCurrentTime() {
            setInterval(() => {
                this.cur_time = new Date().getTime()
            }, 1000)
        },
        getStyle(num, size = 20) {
            return `width:${num.toString().length * size}px`
        },
        showYujing(item) {
            this.cur_item = item
            this.safetyYujingDialog = true
        },
        cancelDialog(data) {
            if (data) this.getYibanSaveList()
            this.safetyYujingDialog = false
        }
    },
    filters: {
        date_time(val) {
            return zhDate(val, 8)
        },
        type(val) {
            switch (Number(val)) {
                case 1 :
                    return '水感警报'
                case 2 :
                    return '烟感警报'
                case 3 :
                    return '摔倒警报'
                case 5:
                    return '充电警报'
                default:
                    return '漏电警报'
            }
        } ,
        service_type(val) {
            switch (Number(val)) {
                case 3 :
                    return '已处理'
                default:
                    return '未处理'
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.container {
    height: 100vh;
    min-width: 1920px;
    min-height: 1080px;
    overflow: hidden;

    .loading {
        color: #ffffff;
        position: fixed;
        background: #33333333;
        z-index: 10;
    }

    .header-container {
        background: url(../../../assets/img/data/bg_monitoring.png) no-repeat top;
        background-size: 100% 100%;
        height: 102px;
        position: relative;
        padding: 0 36px;

        .page-title {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 36px;
            font-weight: 600;
            color: #ffffff;
        }

        .btn-container {
            transform: skew(25deg);
            width: 152px;
            height: 48px;
            min-width: 137px;
            line-height: 48px;
            box-shadow: inset 0px 0px 8px 3px #0096ff;
            background-color: #173979;
            text-align: center;
            font-size: 18px;
            color: #19caff;
            font-weight: 500;
            cursor: pointer;

            &.right {
                transform: skew(-25deg);

                .btn {
                    transform: skew(25deg);
                }
            }

            .btn {
                transform: skew(-25deg);
            }

            &.max {
                width: 282px;
            }

            &.mid {
                width: 182px;
            }
        }


    }


    .content-container {
        position: relative;

        .maps {
            width: 100%;
            height: 100%;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .content-info-container {
            position: absolute;
            left: 26px;
            top: 120px;

            &.right {
                left: unset;
                right: 26px;
            }
        }

        .info-container {
            box-shadow: inset 0px 0px 8px 3px #0096ff;
            background-image: linear-gradient(0deg,
                #0c5da3dd 0%,
                #002262dd 100%);
            background-blend-mode: normal,
            normal;
            position: relative;

            .more {
                color: #0096ff;
                font-size: 12px;
                position: absolute;
                right: 20px;
                top: 20px;
                cursor: pointer;
            }

            .classify-title {
                background: url(../../../assets/img/data/bg_monitoring_title.png) no-repeat top;
                background-size: 100% 100%;
                width: 242px;
                height: 41px;
                line-height: 41px;
                text-align: center;
                font-size: 18px;
                font-weight: 600;
                color: #19caff;
            }

            &.yj-total-container {
                width: 405px;
                height: 755px;
                padding: 0 14px;
                position: relative;

                .operate-container {
                    position: absolute;
                    bottom: 22px;
                    left: 37px;
                    right: 37px;

                    .operate {
                        width: 71px;
                        height: 28px;
                        line-height: 28px;
                        text-align: center;
                        box-shadow: inset 0px 0px 8px 3px #0096ff;
                        font-size: 14px;
                        color: #19caff;
                        cursor: pointer;
                    }

                    .page {
                        width: 71px;
                        font-size: 14px;
                        text-align: center;
                        color: #19caff;
                    }
                }


                .yj-item {
                    height: 79px;
                    background-color: #173979;
                    border-radius: 5px;
                    margin-top: 10px;
                    margin-left: 13px;
                    position: relative;
                    padding-left: 74px;
                    cursor: pointer;

                    &.warn {
                        .time {
                            color: #ffbe41;
                        }

                        .tip-container {
                            background-color: #ffbe41;

                            .status {
                                background-color: #ffbe41;
                                color: #FFFFFF;
                            }
                        }
                    }

                    &.error {
                        .time {
                            color: #ff576f;
                        }

                        .tip-container {
                            background-color: #ff576f;

                            .status {
                                background-color: #e6334c;
                                color: #FFFFFF;
                            }
                        }
                    }

                    .tip-container {
                        position: absolute;
                        width: 73px;
                        height: 63px;
                        background-color: #19caff;
                        border-radius: 5px;
                        top: 50%;
                        left: -13px;
                        transform: translateY(-50%);
                        .type{
                            font-size: 12px;
                            color: #ffffff;
                            margin-bottom: 6px;
                        }
                        .tip {
                            font-size: 16px;
                            color: #ffffff;
                            font-weight: 600;
                        }
                    }

                    .name {
                        font-size: 18px;
                        font-weight: 600;
                        color: #ffffff;
                    }

                    .phone, .address {
                        font-size: 14px;
                        color: #b1c5eb;
                    }

                    .time {
                        position: absolute;
                        right: 10px;
                        top: 0px;
                        font-size: 12px;
                        color: #19caff;
                    }
                }
            }

            &.total-container {
                width: 450px;
                padding: 20px;

                .total-item {
                    width: 200px;
                    height: 121px;
                    background-color: #00226277;
                    border-radius: 10px;
                    border: solid 1px #19caff;
                    margin-top: 10px;

                    &.max {
                        width: 100%;

                        .icon {
                            margin-left: 0;
                        }
                    }

                    .icon {
                        font-size: 28px;
                        color: #19caff;
                        margin-right: 18px;
                        margin-left: 38px;
                    }

                    .image {
                        width: 55px;
                        height: 55px;
                        margin-right: 15px;
                        margin-left: 28px;
                    }

                    .label {
                        font-size: 14px;
                        color: #ffffff;
                        margin-top: 3px;
                        margin-left: 5px;
                    }

                    .number {
                        height: 26px;
                    }

                    .title {
                        font-size: 16px;
                        color: #ffffff;
                    }
                }
            }
        }


    }
}
</style>
